import type { ChatPartRendererMap } from './chatPartRenderer';

// Concrete renderer implementations arrive in later milestones.
export const defaultPartRenderers: ChatPartRendererMap = {};
